import GroupChecklistItemService from '@/service/group-checklist-item'
export default {
  getListGroupChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupChecklistItemService.getListGroupChecklistItem(payload.page, payload.per_page, payload.status).then(res => {
        commit('getListGroupChecklistItem', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  createGroupChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupChecklistItemService.createGroupChecklistItem(payload.group_checklist_item).then(res => {
        commit('createGroupCheckItem', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  createGroupChecklistItemChildren ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupChecklistItemService.createGroupChecklistItem(payload.group_checklist_item).then(res => {
        commit('createGroupChecklistItemChildren', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  showGroupChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupChecklistItemService.showGroupChecklistItem(payload.group_checklist_item, payload.status).then(res => {
        resolve(res.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  destroyGroupChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupChecklistItemService.destroyGroupChecklistItem(payload.group_checklist_item).then(res => {
        commit('destroyGroupChecklistItem', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  updateGroupChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupChecklistItemService.updateGroupChecklistItem(payload.group_checklist_item).then(res => {
        commit('updateGroupChecklistItem', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  approvalGroupChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupChecklistItemService.approvalGroupChecklistItem(payload.group_checklist_item).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  rejectGroupChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupChecklistItemService.rejectGroupChecklistItem(payload.group_checklist_item).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/group-checklist-item/actions.js